import { useWebsiteSettings } from 'client/store'
import React from 'react'
import { useUpdateStoreObjectProp } from 'src/editor/shared/hooks/use-update-store'
import { WebsiteFormFieldGroup } from 'src/editor/shared/settings/wrappers/website-form-field-group'
import { updateWebsiteStylesFormField } from 'src/editor/store/website-settings/website-settings-actions'
import { getWebsiteStylesFormFields } from 'src/editor/store/website-settings/website-settings-selector'
import { WebsiteFormFieldsSettings } from 'src/shared/types/website-settings-types'

export const WebsiteStylesSettingsFormFields = () => {
  const formFieldSettings = useWebsiteSettings(getWebsiteStylesFormFields)
  const updateFormFieldProp = useUpdateStoreObjectProp(
    formFieldSettings as WebsiteFormFieldsSettings,
    updateWebsiteStylesFormField,
  )

  return (
    <WebsiteFormFieldGroup
      updateWebsiteStylesFormField={updateFormFieldProp}
      formFieldSettings={formFieldSettings as WebsiteFormFieldsSettings}
    />
  )
}
